module.exports = __webpack_public_path__ + "img/logo_login.08c1e068.png";